import { BaseDto } from './base.dto';
import { StockDto } from './stock.dto';

export class DietDto extends BaseDto {
  id: number;
  name: string;
  code: string;
  startDate?: Date;
  endDate?: Date;
  stock: StockDto[];
}
